


































































































































































































































import { EmailDetailItemInfo } from '@/store/email/statistic/types';
import { colorClassByStatus } from '@/utils/page-utils';
import { dateFilter } from '@/utils/date-util';
import { notifyDelete, notifyError, notifySuccess } from '@/utils/notify-helper';
import { Vue, Component } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import EmailDetailInfoDialog from '@/components/Email/Statistic/EmailDetailInfoDialog.vue';
import axios from "axios";
import {getTranslatedParams} from "@/utils/notify-utils";
import {MsgTransports} from "@/store/types";
import {ActionLog} from "@/store/auth/types";

type Func<T> = (id: string) => T;

@Component({
  components: {EmailDetailInfoDialog},
  filters: {dateFilter},
  methods: {colorClassByStatus},
})
export default class EmailDetailInfo extends Vue {

  @Action("getEmailStatisticDetailInfo") actionGetItem: any;
  @Action("getEmailMessage") actionGetMessage: any;
  @Action("checkEmailMessage") actionCheckMessage: any;
  @Action("resendEmailMessage") actionResendMessage: any;
  @Action("actionLog") actionLog: any;

  private messageInfo: EmailDetailItemInfo = new EmailDetailItemInfo();
  private messageContent: string|null = null;
  private showMessage: boolean = false;
  private transport = MsgTransports.EMAIL;
  private logObject: ActionLog = {};

  get isShowFinInf(): boolean {
    return localStorage.getItem('show-finance-info') === 'true';
  }

  async created(): Promise<void> {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Message",
        addititional_info: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
      }
      this.messageInfo = await this.actionGetItem(this.$route.params.id);
      this.messageContent = await this.actionGetMessage(this.$route.params.id);
      await this.actionLog(this.logObject);
    }
    catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }

  back(): void {
    this.$router.push('/email/detail/');
  }

  async resend(): Promise<void> {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Resending",
        action_status: "success",
        object_type: "Message",
        addititional_info: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
      }
      const data = {message_ids: [this.$route.params.id]}
      const resp = await this.actionCheckMessage(data);
      await this.actionLog(this.logObject);
      if (resp.data?.success && resp.data.success?.count == 1) {
        this.resendFunction(data)
      }
      if (resp.data?.failed) {
        if (resp.data.failed?.without_template && resp.data.failed.without_template?.count == 1) {
          if (await notifyDelete(this.$t('errors.email_resend_failed_whithout_template').toString())) {
            this.resendFunction(data)
          }
        }
        if (resp.data.failed?.without_text && resp.data.failed.without_text?.count == 1) {
          notifyError(null, null, this.$t('errors.email_resend_failed_whithout_text').toString());
        }
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }

  async resendFunction(data: any) {
    const resp = await this.actionResendMessage(data);
    if (resp.data.status === 'Success') {
      notifySuccess(this.$t('dialog.resend').toString());
    }
  }
}
